// extracted by mini-css-extract-plugin
export default {"coverTheEachHere":"investmentPlans_coverTheEachHere__Fgxtc","absoluteDelete":"investmentPlans_absoluteDelete__efvGm","coverTheMap":"investmentPlans_coverTheMap__iddbA"};